// @core/api/endpoints/tenant/get_tenant.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Get tenant by ID (respects privacy settings)
 * Retrieves tenant details by ID. Access is controlled by tenant privacy settings: public tenants are visible to all, while private tenants require membership.
 */
export async function GetTenant(
  tenant_id: string,
  options?: RequestOptions
): Promise<TenantResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<TenantResponse>(requestPath, { ...requestOptions });
}
